<template>
    <div class="mask">
        <div class="header">
            <div></div>
            <div class="tit">暗网</div>
            <div></div>
        </div>
        <DarkAd v-if="store.showDarksideAd" :list="[...store.darksidead]"></DarkAd>
        <div class="mask-list">
            <div v-for="(item, index) in list" :key="item.id" class="mask-item">
                <div class="mask-title">
                    <div class="flex">
                        <img src="/kl.png" style="width: 16px;height: 16px;" />
                        <div class="ditname">{{ item.dictName }}</div>
                    </div>
                    <!-- <div class="flex" @click="onGo(item, index)">
                        <div>查看更多</div>
                        <van-icon name="arrow" />
                    </div> -->
                </div>
                <div class="mask-li" v-if="item.relationMovies.length !== 0">
                    <div v-for="(i, index) in item.relationMovies" :key="index"
                        :class="['cartoon-item', { 'full-width': index === 0 }]">
                        <div v-show="!loadedMap[i.cartoonCode]"
                            :class="['skeleton-item', { 'full-width': index === 0 }]">
                            <div class="skeleton-img">
                                <van-loading type="spinner" />
                            </div>
                               <div class="skeleton-text">{{ item.cartoonName }}</div>
                        </div>
                        <PbCateInfoItem v-show="loadedMap[i.cartoonCode]" @goVideo="handleGoVideo" :key="item.id"
                            :item="i" :index="index" @error="onImgError" title="暗网" @imgLoaded="handleImgLoaded">
                        </PbCateInfoItem>
                    </div>
                </div>
                <div class="mask-li" v-else>敬请期待...</div>
                <!-- <div class="change-bt">
                    <div class="c-left" @click="onGo(item, index)">查看更多</div>
                    <div class="c-right" @click="onRef(item, index)"><van-icon name="replay"
                            :class="{ spinning: loadingIndex === index }" /> 换一批</div>
                </div> -->
            </div>
            <van-back-top bottom="10vh" :style="{ backgroundColor: '#FF960C', borderRadius: '50%' }" />
            <div style="height: 50px;"></div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { onMounted, ref, reactive } from 'vue'
import { post } from '@/utils/request'
import AES from '@/utils/aes1.js'
import PbCateInfoItem from "@/components/PbCateInfoItem.vue"
import { useRouter } from "vue-router";
import { useHomeStore } from '@/store/home'
import DarkAd from "@/components/DarkAd.vue"
const store = useHomeStore()
const router = useRouter()
const list = ref<any>([
    {
    dictName: '重口味',
    dictCode: 119,
    type: 0,
    pid: 42,
    sorts: 49,
    relationMovies: [
  {
    cartoonCode: '26315',
    cartoonName: 'Nimfa - 20 декабря 2010',
    cartoonIntroduce: 'Nimfa - 20 декабря 2010',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20240723/urR8I2E0/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '119',
    cartoonHot: 245,
    createTime: 'Feb 3, 2026 3:18:32 PM',
    updateTime: 'Feb 3, 2026 3:18:32 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20240723/urR8I2E0/1.jpg',
    vodDuration: '13:04',
    vodHits: 244,
    vodHitsDay: 41,
    vodHitsWeek: 348,
    vodHitsMonth: 660,
    praiseNum: 19,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '23698',
    cartoonName: '【SM调教】高颜值母狗，脖子套狗链牵着狂操',
    cartoonIntroduce: '【SM调教】高颜值母狗，脖子套狗链牵着狂操',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20250927/t7ewbs9L/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '119',
    cartoonHot: 8,
    createTime: 'Feb 3, 2026 3:06:19 PM',
    updateTime: 'Feb 3, 2026 3:06:19 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.kdhgfs.cc/20250927/t7ewbs9L/1.jpg',
    vodDuration: '29:00',
    vodHits: 5,
    vodHitsDay: 108,
    vodHitsWeek: 969,
    vodHitsMonth: 885,
    praiseNum: 215,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '24071',
    cartoonName: '爱吃鸡巴的小母狗',
    cartoonIntroduce: '爱吃鸡巴的小母狗',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20250110/BLRWpUga/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '119',
    cartoonHot: 780,
    createTime: 'Feb 3, 2026 3:08:34 PM',
    updateTime: 'Feb 3, 2026 3:08:34 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20250110/BLRWpUga/1.jpg',
    vodDuration: '17:53',
    vodHits: 780,
    vodHitsDay: 612,
    vodHitsWeek: 138,
    vodHitsMonth: 643,
    praiseNum: 426,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '26466',
    cartoonName: '双飞人妖的快乐',
    cartoonIntroduce: '双飞人妖的快乐',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20240816/MJjMPxeq/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '119',
    cartoonHot: 279,
    createTime: 'Feb 3, 2026 3:18:57 PM',
    updateTime: 'Feb 3, 2026 3:18:57 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20240816/MJjMPxeq/1.jpg',
    vodDuration: '02:20',
    vodHits: 277,
    vodHitsDay: 866,
    vodHitsWeek: 123,
    vodHitsMonth: 692,
    praiseNum: 692,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '26531',
    cartoonName: '极品性感伪娘盛宴',
    cartoonIntroduce: '极品性感伪娘盛宴',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20240816/MYcr7dMd/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '119',
    cartoonHot: 150,
    createTime: 'Feb 3, 2026 3:19:08 PM',
    updateTime: 'Feb 3, 2026 3:19:08 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20240816/MYcr7dMd/1.jpg',
    vodDuration: '13:49',
    vodHits: 148,
    vodHitsDay: 693,
    vodHitsWeek: 814,
    vodHitsMonth: 571,
    praiseNum: 86,
    isFeatured: 0,
    randSeed: 0
  }
]
  },
  {
    dictName: '恐怖',
    dictCode: 120,
    type: 0,
    pid: 42,
    sorts: 50,
    relationMovies: [
  {
    cartoonCode: '6760',
    cartoonName: 'Zoophile女同性恋女友与自己的狗发生关系',
    cartoonIntroduce: 'Zoophile女同性恋女友与自己的狗发生关系',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20240928/m5BELOYr/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '122',
    cartoonHot: 81,
    createTime: 'Jan 24, 2026 6:13:13 PM',
    updateTime: 'Jan 24, 2026 6:13:13 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20240928/m5BELOYr/1.jpg',
    vodDuration: '04:49',
    vodHits: 76,
    vodHitsDay: 981,
    vodHitsWeek: 285,
    vodHitsMonth: 798,
    praiseNum: 336,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '7083',
    cartoonName: '戴眼镜的女孩正在为里面的狗鸡巴做准备',
    cartoonIntroduce: '戴眼镜的女孩正在为里面的狗鸡巴做准备',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20240928/GflMxF0u/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '122',
    cartoonHot: 852,
    createTime: 'Jan 24, 2026 6:13:34 PM',
    updateTime: 'Jan 24, 2026 6:13:34 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20240928/GflMxF0u/1.jpg',
    vodDuration: '04:51',
    vodHits: 849,
    vodHitsDay: 826,
    vodHitsWeek: 317,
    vodHitsMonth: 412,
    praiseNum: 687,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '7256',
    cartoonName: 'XXX 兽交视频特写他妈的',
    cartoonIntroduce: 'XXX 兽交视频特写他妈的',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20240928/ZAEpWnTI/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '122',
    cartoonHot: 944,
    createTime: 'Jan 24, 2026 6:13:44 PM',
    updateTime: 'Jan 24, 2026 6:13:44 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20240928/ZAEpWnTI/1.jpg',
    vodDuration: '04:49',
    vodHits: 934,
    vodHitsDay: 309,
    vodHitsWeek: 509,
    vodHitsMonth: 958,
    praiseNum: 262,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '7012',
    cartoonName: '黑狗用屁股对屁股的姿势操一个看起来性感的小妞',
    cartoonIntroduce: '黑狗用屁股对屁股的姿势操一个看起来性感的小妞',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20240928/x8HIbMz6/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '122',
    cartoonHot: 128,
    createTime: 'Jan 24, 2026 6:13:29 PM',
    updateTime: 'Jan 24, 2026 6:13:29 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20240928/x8HIbMz6/1.jpg',
    vodDuration: '04:51',
    vodHits: 127,
    vodHitsDay: 437,
    vodHitsWeek: 966,
    vodHitsMonth: 657,
    praiseNum: 586,
    isFeatured: 0,
    randSeed: 0
  },
  {
    cartoonCode: '2486',
    cartoonName: '猎奇带你看看老母猪的逼',
    cartoonIntroduce: '猎奇带你看看老母猪的逼',
    cartoonVip: 1,
    cartoonImage: 'https://pdy.zydhfh6fg.cc/20250327/EXykHfMh/1.jpg',
    cartoonAuthor: '',
    cartoonScore: 0,
    dictCode: '42',
    sonDictCode: '122',
    cartoonHot: 860,
    createTime: 'Jan 24, 2026 6:08:13 PM',
    updateTime: 'Jan 24, 2026 6:08:13 PM',
    channelId: '1',
    channel: 'SuperMan',
    moviesPrice: 50,
    onePrice: 2,
    cartoonImageBefore: 'https://player.oiendj.cc/20250327/EXykHfMh/1.jpg',
    vodDuration: '00:00:41',
    vodHits: 814,
    vodHitsDay: 378,
    vodHitsWeek: 993,
    vodHitsMonth: 84,
    praiseNum: 540,
    isFeatured: 0,
    randSeed: 0
  }
]
  },
])
const loadingIndex = ref<any>('')
const onGetData = async () => {
    const res = await post('/app-api/cartoon/selectSubjectByName', {
        dictName: '暗网',
        type: 0
    })
    if (res.code === 0) {
        const data = JSON.parse(AES.decrypt(res.data, 'asdasdsadasdasds', '5245847584125485'))
        console.log(data, "data");
        list.value = data
    }
}
const handleGoVideo = (item: any) => {
    console.log('即将跳转', item.cartoonCode)
    router.push({
        path: '/videoinfo',
        query: { id: item.cartoonCode }
    }).catch(err => console.warn(err))
}
const loadedMap = reactive<any>({
})
// 初始化
const handleImgLoaded = ({
    title,
    index,
    time,
    id
}: {
    title: string
    index: number
    time: number,
    id: any
}) => {
    loadedMap[id] = true
}

const onImgError = () => {

}
const onGo = async (item: any, index: any) => {
    router.push({
        path: '/sreinfo',
        query: {
            type: item.pid,
            sonType: item.dictCode,
            searchStr: '',
            title: '暗网'
        }
    })
}
const onRef = async (item: any, index: any) => {
    console.log(item,"item");
    
    loadingIndex.value = index;
    const res = await post('/app-api/cartoon/changeBatch', {
        currentPage: 1,
        sonTypeCode: item.dictCode,
        typeCode: 42
    })
    if (res.code === 0) {
        const data = JSON.parse(AES.decrypt(res.data, 'asdasdsadasdasds', '5245847584125485'))
        console.log(data, "data");
        list.value[index].relationMovies = data
    }
    loadingIndex.value = '';
}
onMounted(async () => {
   await onGetData()
    await store.getConfig()
})
</script>
<style lang="less" scoped>
.mask {
    height: 100vh;
    padding: 10px;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;

        .tit {
            font-weight: bold;
        }
    }

    .mask-list {
        height: calc(100vh - 50px);
        overflow: auto;

        .mask-item {

            .mask-title {
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;

                .flex {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    line-height: 25px;
                    font-size: 13px;

                    .ditname {
                        color: var(--primary-color);
                        color: rgb(255, 150, 12);
                        font-size: 16px;
                        margin-left: 10px;
                    }
                }
            }
        }

        .change-bt {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .c-left {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 48%;
                height: 32px;
                border-radius: 20px;
                font-size: 16px;
                padding-left: 6px;
                background: linear-gradient(rgb(255, 190, 0) 0%, rgb(255, 150, 12) 104.01%);
                color: black;
                font-weight: bold;
            }

            .c-right {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 48%;
                height: 32px;
                border-radius: 20px;
                font-size: 16px;
                padding-left: 6px;
                background: linear-gradient(rgb(255, 190, 0) 0%, rgb(255, 150, 12) 104.01%);
                color: black;
                font-weight: bold;
            }
        }

    }

    .mask-li {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
}

.spinning {
    animation: spin 0.2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.cartoon-item {
    width: 48%;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
}

.full-width {
    width: 100% !important;

    .img-wrapper {
        height: 200px;
        background-image: url("/Image/pl.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}
</style>